// Legacy is C#: the published date must be written as an exact ISO-8601 UTC string at midnight,
// e.g. "2026-06-05T00:00:00Z". A malformed value (extra precision, offset, missing Z) can crash
// legacy on deserialization, so the value is formatted strictly and validated before it is sent.
export const LEGACY_PUBLISHED_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T00:00:00Z$/

// Formats a picked date to the canonical legacy string using its calendar day, so the day the
// author selected is preserved regardless of timezone (avoids toISOString() day-shifting).
export function formatLegacyPublishedDate(date) {
    const value = date instanceof Date ? date : new Date(date)
    if (Number.isNaN(value.getTime())) return null

    const year = value.getFullYear()
    const month = String(value.getMonth() + 1).padStart(2, "0")
    const day = String(value.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}T00:00:00Z`
}
